import type { MeasurementSystem } from './distance';

// Should be generated by the backend?
// should we use the SupportedCountry from 'generated/graphql', same as the one in graphql?
export const SupportedCountries = ['NZ', 'AU', 'US'] as const;
export type SupportedCountry = (typeof SupportedCountries)[number];

export interface CountryInfo {
    shortName: string;
    name: string;
    nameCasual: string;
    domain: string;
    /**
     * Primary content language for the market as an ISO 639-1 code (e.g. `en`).
     * All markets are English-only today; this is the single input from which
     * hreflang (`en-us`) and og:locale (`en_US`) are derived, so adding a
     * future non-English market is a config change rather than a code change.
     */
    language: string;
    /** Unicode regional-indicator flag for UI menus. */
    flagEmoji: string;
}

export type ConsentMode = 'none' | 'notice' | 'opt-in';

export interface CountryConfig {
    consentMode: ConsentMode;
    honourGlobalPrivacyControl: boolean;
    phoneCountryCode: string | null;
    allowProducts: boolean;
    allowMemberGuides: boolean;
    allowMemberOrders: boolean;
    allowMemberTickets: boolean;
    showHDENavLink: boolean;
    measurementSystem: MeasurementSystem;
}

export interface LocalisationData {
    locales: string[];
    timezone: string;
    country: SupportedCountry;
    countryConfig: CountryConfig;
}
